import { storage as Storage } from './Storage';

const PAGE_SIZE = 'pageSize';
const itemsPerPageOptions = [20, 50, 100, 200];

const getValidPageSize = (): number => {
  let size = parseInt(Storage.getItem(PAGE_SIZE) as string);
  if (!size || !itemsPerPageOptions.includes(size)) {
    size = itemsPerPageOptions[0];
    Storage.setItem(PAGE_SIZE, size as unknown as string);
  }
  return size;
};

export const getPageSize = (size?: number | string): number => {
  if (typeof size !== 'undefined') {
    Storage.setItem(PAGE_SIZE, size as string);
    return getValidPageSize();
  } else {
    return getValidPageSize();
  }
};

export const pageSize = getPageSize;
